export default "__VITE_ASSET__CDRvs2x0__"